import { createLoader } from '@spotify-internal/creator-data-loading';
import { SearchResponse, SearchQuery, SearchHit } from '.';
import { fetchEntryList } from '../Contentful';
import { apiCall } from '../utils';
import { itemToSearchHit } from './content';

const USE_ELASTIC = false;

const searchLoaderContentful = createLoader<SearchQuery, SearchResponse>(
  async (query: SearchQuery): Promise<SearchResponse> => {
    const { limit = 10, skip = 0, contentTypes } = query;

    const q = query.query;

    let params;
    if (contentTypes?.length === 1 && contentTypes?.[0] === 'faq') {
      params = {
        contentType: 'faq',
        limit,
        skip,
        filters: {
          'indexed[nin]': false,
          'question[exists]': true,
          'answer[exists]': true,
        },
        select: ['fields.question', 'fields.urlSlug'],
        query: q,
      };
    } else {
      params = {
        limit,
        skip,
        query: q,
      };
    }
    const resp = await fetchEntryList(params);

    return {
      hits: resp.entries.map(itemToSearchHit).filter(Boolean) as NonNullable<
        SearchHit
      >[],
      limit: resp.limit,
      skip: resp.skip,
      query: q,
      total: resp.total,
    };
  },
  {
    cacheKeyFn: JSON.stringify,
  },
);

const searchLoaderElastic = createLoader<SearchQuery, SearchResponse>(
  async (query: SearchQuery): Promise<SearchResponse> => {
    const resp = await apiCall('v1/search', query);
    return resp;
  },
  {
    cacheKeyFn: JSON.stringify,
  },
);

export const searchLoader = USE_ELASTIC
  ? searchLoaderElastic
  : searchLoaderContentful;
